import { NavItem } from './nav-item/nav-item';

export const navItemsRestaurante: NavItem[] = [
  {
    navCap: 'Gerenciador',
  },
  {
    displayName: 'Meu Restaurante',
    iconName: 'chef-hat',
    route: '/meu-restaurante',
  },
  {
    displayName: 'Meu plano',
    iconName: 'receipt-2',
    route: '/meu-plano',
  },
  {
    displayName: 'Vouchers',
    iconName: 'ticket',
    route: '/vouchers',
  },
];

export const navItemsFestival: NavItem[] = [
  {
    navCap: 'Festivais',
  },
  {
    displayName: 'Brasil Sabor',
    iconName: 'star-filled',
    children: [
      { displayName: 'Circuito Gourmet', iconName: 'qrcode', route: '/sabor-brasil/qr' },
      { displayName: 'Resgatar Brinde', iconName: 'gift', route: '/sabor-brasil/brinde' },
    ],
  },
];
